<template>
  <svg
    class="custom-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M3.5 4C3.5 3.44772 3.94772 3 4.5 3H6.5C7.05228 3 7.5 3.44772 7.5 4V14C7.5 14.5523 7.05228 15 6.5 15H4.5C3.94772 15 3.5 14.5523 3.5 14V4Z"
    />
    <path
      d="M10.5 4C10.5 3.44772 10.9477 3 11.5 3H13.5C14.0523 3 14.5 3.44772 14.5 4V14C14.5 14.5523 14.0523 15 13.5 15H11.5C10.9477 15 10.5 14.5523 10.5 14V4Z"
    />
  </svg>
</template>
